import React from 'react';
import { motion } from 'framer-motion';
export function Footer() {
  return <footer className="bg-cream border-t border-stone py-12 md:py-16" data-id="element-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-21">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-22">
          {/* Logo */}
          <div className="text-charcoal font-serif text-xl" data-id="element-23">Yearn</div>

          {/* Links */}
          <div className="flex flex-wrap justify-center gap-8" data-id="element-24">
            {['About', 'FAQ', 'Privacy', 'Terms'].map(link => <a key={link} href="#" className="text-xs uppercase tracking-widest text-warm-gray hover:text-charcoal transition-colors" data-id="element-25">
                {link}
              </a>)}
          </div>

          {/* Tagline */}
          <div className="text-warm-gray italic font-serif text-sm" data-id="element-26">
            Written slowly. Sent intentionally.
          </div>
        </div>

        <div className="mt-12 text-center text-[10px] text-stone-400 uppercase tracking-widest" data-id="element-27">
          © {new Date().getFullYear()} Yearn. All rights reserved.
        </div>
      </div>
    </footer>;
}